<template>
  <v-app>
    <!--begin::Card-->
    <div class="card card-custom">
      <!--begin::Header-->
      <div class="card-header py-5">
        <div class="card-title align-items-start flex-column">
          <h3 class="card-label font-weight-bolder text-dark">
            General Information
          </h3>

        </div>
        <div class="card-toolbar">
          <!--          <button type="reset" class="btn btn-secondary" @click="cancel()">-->
          <!--            Cancel-->
          <!--          </button>-->
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Form-->
      <div v-if="loading">
        <v-skeleton-loader
            v-bind="attrs"
            type="list-item-three-line"
        ></v-skeleton-loader>
        <v-skeleton-loader
            v-bind="attrs"
            type="list-item-three-line"
        ></v-skeleton-loader>
        <v-skeleton-loader
            v-bind="attrs"
            type="list-item-three-line"
        ></v-skeleton-loader>
      </div>
      <div v-else>
        <form class="form">
          <!--begin::Body-->
          <div class="card-body">
            <div class="row">
              <label class="col-xl-3"></label>
              <div class="col-lg-9 col-xl-6">

                <!--                        <h5 class="font-weight-bold mb-6">General Info</h5>-->
                <!--                        <div class="d-flex align-items-center justify-content-between mb-2"-->
                <!--                             v-if="checkUserIncludes(user.type,'student')">-->
                <!--                          <span class="font-weight-bold mr-2">Symbol No.</span>-->
                <!--                          <a class=" text-hover-primary">{{-->
                <!--                              user.setting && user.setting.symbol_no ?-->
                <!--                                  user.setting.symbol_no : 'N/A'-->
                <!--                            }}</a>-->
                <!--                        </div>-->
                <!--                        <div class="d-flex align-items-center justify-content-between mb-2"-->
                <!--                             v-if="checkUserIncludes(user.type,'student')">-->
                <!--                          <span class="font-weight-bold mr-2">Board Reg. No.</span>-->
                <!--                          <a class=" text-hover-primary">{{-->
                <!--                              user.setting && user.setting.board_registration_number ?-->
                <!--                                  user.setting.board_registration_number : 'N/A'-->
                <!--                            }}</a>-->
                <!--                        </div>-->
                <!--                        <div class="d-flex align-items-center justify-content-between mb-2"-->
                <!--                             v-if="checkUserIncludes(user.type,'student') && user.setting && user.setting.midas_id">-->
                <!--                          <span class="font-weight-bold mr-2">Midas ID</span>-->
                <!--                          <a class=" text-hover-primary">{{-->
                <!--                              user.setting ?-->
                <!--                                  user.setting.midas_id ? user.setting.midas_id : 'N/A' : 'N/A'-->
                <!--                            }}</a>-->
                <!--                        </div>-->
                <!--                        <div class="d-flex align-items-center justify-content-between mb-2">-->
                <!--                          <span class="font-weight-bold mr-2">Email</span>-->
                <!--                          <a class=" text-hover-primary">{{ user.email ? user.email : 'N/A' }}</a>-->
                <!--                        </div>-->
                <!--                        <div class="d-flex align-items-center justify-content-between mb-2">-->
                <!--                          <span class="font-weight-bold mr-2">Phone</span>-->
                <!--                          <span class="">{{ user.phone ? user.phone : 'N/A' }}</span>-->
                <!--                        </div>-->
                <!--                        <div class="d-flex align-items-center justify-content-between mb-2"-->
                <!--                             v-if="checkUserIncludes(user.type,'student')">-->
                <!--                          <span class="font-weight-bold mr-2">Father Name</span>-->
                <!--                          <span class="">{{-->
                <!--                              user.father && user.father.length > 0 ? user.father[0]['full_name'] : 'N/A'-->
                <!--                            }}</span>-->
                <!--                        </div>-->
                <!--                        <div class="d-flex align-items-center justify-content-between mb-2"-->
                <!--                             v-if="checkUserIncludes(user.type,'student')">-->
                <!--                          <span class="font-weight-bold mr-2">Mother Name</span>-->
                <!--                          <span class="">{{-->
                <!--                              user.mother && user.mother.length > 0 ? user.mother[0]['full_name'] : 'N/A'-->
                <!--                            }}</span>-->
                <!--                        </div>-->
                <!--                        <div class="d-flex align-items-center justify-content-between mb-2"-->
                <!--                             v-if="checkUserIncludes(user.type,'student')">-->
                <!--                          <span class="font-weight-bold mr-2">Local Guardian</span>-->
                <!--                          <span class="">{{-->
                <!--                              user.guardian && user.guardian.length > 0 ? user.guardian[0]['full_name'] : 'N/A'-->
                <!--                            }}</span>-->
                <!--                        </div>-->
                <!--                        <div class=" mb-2">-->
                <!--                          <div class="font-weight-bold mr-2">Permanent Address</div>-->
                <!--                          <div class="" >-->
                <!--                            {{-->
                <!--                              user.permanent_address && user.permanent_address.length > 0 ? user.permanent_address[0]['full_address'] :-->
                <!--                                  'N/A'-->
                <!--                            }}-->
                <!--                          </div>-->

                <!--                        </div>-->
                <!--                        <div class=" mb-2">-->
                <!--                          <div class="font-weight-bold mr-2">Temporary Address</div>-->
                <!--                          <div class="">-->
                <!--                            {{-->
                <!--                              user.temporary_address && user.temporary_address.length > 0 ? user.temporary_address[0]['full_address'] :-->
                <!--                                  'N/A'-->
                <!--                            }}-->
                <!--                          </div>-->
                <!--                        </div>-->
              </div>
            </div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >Profile Image</label
              >
              <div class="col-lg-9 col-xl-6">
                <div class="image-input image-input-outline" id="kt_profile_avatar">
                  <div
                      class="ad"
                  >
                    <img class="image-input-wrapper" :src="user.image_path.real"
                         v-if="user.image_path && user.image_path.real" alt="">
                    <img class="image-input-wrapper" v-else
                         src="https://images.unsplash.com/photo-1509114397022-ed747cca3f65?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2550&q=80"
                         alt="">
                  </div>
                  <span
                      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                      data-action="cancel"
                      data-toggle="tooltip"
                      title="Cancel avatar"
                  >
                <i class="ki ki-bold-close icon-xs text-muted"></i>
              </span>
                </div>
                <span class="form-text text-muted"
                >Allowed file types: png, jpg, jpeg.</span
                >
              </div>
            </div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >First Name</label
              >
              <div class="col-lg-9 col-xl-6">
                <v-text-field outlined dense
                              label="First Name"
                              v-model="user.first_name"
                              readonly
                >
                </v-text-field>
                <!--              <input-->
                <!--                  ref="name"-->
                <!--                  v-model="user.first_name"-->
                <!--                  class="form-control form-control-lg form-control-solid"-->
                <!--                  type="text"/>-->
                <!--              v-bind:value="currentUserPersonalInfo.name"-->

              </div>
            </div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >Middle Name</label
              >
              <!--                        {{currentUser.type}}-->
              <div class="col-lg-9 col-xl-6">
                <v-text-field outlined dense
                              label="Middle Name"
                              v-model="user.middle_name"
                >
                </v-text-field>
                <!--              <input-->

                <!--                  v-model="user.middle_name"-->
                <!--                  ref="middle_name"-->
                <!--                  class="form-control form-control-lg form-control-solid"-->
                <!--                  type="text"/>-->
                <!--              v-bind:value="currentUserPersonalInfo.surname"-->

              </div>
            </div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >Last Name</label
              >
              <div class="col-lg-9 col-xl-6">
                <v-text-field outlined dense
                              label="Last Name"
                              v-model="user.last_name"
                >
                </v-text-field>
                <!--              <input-->

                <!--                  v-model="user.last_name"-->
                <!--                  ref="surname"-->
                <!--                  class="form-control form-control-lg form-control-solid"-->
                <!--                  type="text"/>-->
                <!--              v-bind:value="currentUserPersonalInfo.surname"-->

              </div>
            </div>
            <!--          <div class="row" v-if="currentUser.type=='admin'">-->
            <!--            <label class="col-xl-3"></label>-->
            <!--            <div class="col-lg-9 col-xl-6">-->
            <!--              <h5 class="font-weight-bold mt-10 mb-6">Contact Info</h5>-->
            <!--            </div>-->
            <!--          </div>-->
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >Contact Phone</label
              >
              <div class="col-lg-9 col-xl-6">
                <v-text-field outlined dense
                              label="Phone"
                              append-icon="fas fa-phone"
                              v-model="user.phone"
                              readonly
                >
                </v-text-field>

              </div>
            </div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >Contact Mobile</label
              >
              <div class="col-lg-9 col-xl-6">
                <v-text-field outlined dense
                              label="Mobile"
                              append-icon="fas fa-mobile"
                              v-model="user.mobile"
                              readonly
                >
                </v-text-field>
                <span class="text-danger" v-if="phone_exists">Mobile Number in use</span>


              </div>
            </div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >Email Address</label
              >
              <div class="col-lg-9 col-xl-6">
                <v-text-field outlined dense
                              label="Email"
                              append-icon="fas fa-envelope"
                              v-model="user.email"
                              readonly
                >
                </v-text-field>
              </div>
            </div>
            <hr>
<!--            <pre>{{setting}}</pre>-->
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >Program</label
              >
              <div class="col-lg-9 col-xl-6">
                <v-text-field outlined dense
                              label="Program"
                              v-model="setting.program_title"
                              readonly
                >
                </v-text-field>
              </div>
            </div><div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >Academic Year</label
              >
              <div class="col-lg-9 col-xl-6">
                <v-text-field outlined dense
                              label="Academic Year"
                              v-model="setting.academic_year"
                              readonly
                >
                </v-text-field>
              </div>
            </div>
<div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >Class</label
              >
              <div class="col-lg-9 col-xl-6">
                <v-text-field outlined dense
                              label="Class"
                              v-model="setting.current_semester_title"
                              readonly
                >
                </v-text-field>
              </div>
            </div>
            <hr><div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-right"
              >Address</label
              >
              <div class="col-lg-9 col-xl-6">
                <v-text-field outlined dense
                              label="Class"
                              v-model="setting.id_card_address"
                              readonly
                >
                </v-text-field>
              </div>
            </div>

            <!--          <div class="form-group row" v-if="currentUser.type=='admin'">-->
            <!--            <label class="col-xl-3 col-lg-3 col-form-label text-right"-->
            <!--            >Description</label-->
            <!--            >-->
            <!--            <div class="col-lg-9 col-xl-6">-->
            <!--              <v-textarea outlined dense-->
            <!--                            label="Description"-->
            <!--                            v-model="user.email"-->
            <!--              >-->
            <!--              </v-textarea>-->
            <!--              <span class="form-text text-muted"-->
            <!--              >We'll never share your email with anyone else.</span-->
            <!--              >-->
            <!--            </div>-->
            <!--          </div>-->
          </div>
          <!--end::Body-->
        </form>
      </div>

      <!--end::Form-->
    </div>
  </v-app>
</template>

<script>
// import { UPDATE_PERSONAL_INFO } from "@/core/services/store/profile.module";
import UserService from "@/core/services/user/UserService";
import {required, email} from "vuelidate/lib/validators";

const userService = new UserService();

export default {
  name: "StudentGeneralInformation",
  props: ['user', 'setting'],
  data() {
    return {
      attrs: '',
      isBusy: false,
      loading: false,
      phone_exists: false,
      email_exists: false,
      default_photo: "media/users/blank.png",
      current_photo: null,
      studentSetting: null,
      data_photo: null,
    };
  },
  mounted() {
    // this.current_photo = this.currentUserPersonalInfo.photo;
  },

  methods: {},
  computed: {
    id() {
      if (this.currentUser.type == 'admin')
        return this.$route.params.id ? this.$route.params.id : false;
      else if (this.currentUser.type != 'admin')
        return this.currentUser.id;

    },
    rules() {
      let rule = {
        first_name: {required},
        last_name: {required},
        email: {email},

      };
      if (!this.id) {
        rule.email = {required};
        rule.phone = {required};
      }
      if (this.user.account_type != 'student')
        rule.email = {required, email}
      return rule;
    },
    photo() {
      return this.current_photo == null
          ? this.default_photo
          : this.current_photo;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
  }
};
</script>
